import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from 'react-redux';
import { FaTimes } from 'react-icons/fa';

import { FlyInTransition } from '../transitions/transitions';
import { closeIFrame } from '../../actions';
import Modal from '../../containers/common/Modal.js';

const OuterContainer = styled.div`
  background: #fff;
  border-radius: 12px 12px 0px 0px;
  font-family: Inter;
  height: 90%;
  width: 100vw;
  position: absolute;
  bottom: 0;
  padding: 12px 6px;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 440px;
  @media only screen and (min-width: 440px) {
    // width: 80vw;
  }
`;

const Header = styled.div`
  font-family: 14px;
  font-weight: 500;
  width: 100%;
  padding: 10px;
  padding-top: 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #f0f3f6;
`;

const CloseContainer = styled.div`
  width: 1.625rem;
  height: 1.625rem;
  border-radius: 8px;
  border: 1px solid #eee;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CloseIcon = styled(FaTimes)`
  color: #413958;
`;

const IFrame = ({}) => {
  const url = useSelector((state) => state.app.iFrame.contentUrl);
  const [open, setOpen] = useState(true);
  const dispatch = useDispatch();
  const timer = useRef(null);

  const handleClose = () => {
    setOpen(false);
    timer.current = setTimeout(() => {
      dispatch(closeIFrame());
    }, 300);
  };

  useEffect(() => {
    return () => {
      if (timer.current) clearTimeout(timer.current);
    };
  }, []);

  return (
    <Modal>
      <div className="modalContainer">
        <FlyInTransition in={open} mountOnEnter unmountOnExit appear>
          <OuterContainer>
            <Header>
              <div className="flex flex-row items-center">Support</div>
              <CloseContainer onClick={handleClose}>
                <CloseIcon />
              </CloseContainer>
            </Header>
            <iframe
              title="Embedded URL"
              src={url}
              style={{ width: '100%', height: '95%', border: 'none' }}
              onLoad={(e) => e.preventDefault()}
            />
          </OuterContainer>
        </FlyInTransition>
      </div>
    </Modal>
  );
};

export default IFrame;
